import { FC } from 'react';

import { FullVatMention } from '@/productDiscovery/ProductPage/common/modules/Price/XBorderVatMentions/FullVatMention';
import { ZeroVatMention } from '@/productDiscovery/ProductPage/common/modules/Price/XBorderVatMentions/ZeroVatMention';
import { type XBorderVat } from '@/productDiscovery/ProductPage/hooks/useXBorderVat';

export const XBorderMentions: FC<{ vatStatus?: XBorderVat }> = ({
  vatStatus,
}) => {
  if (vatStatus == 'zero') return <ZeroVatMention />;

  if (vatStatus == 'nonDeductible') return <FullVatMention />;

  return null;
};
